import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useState } from 'react';
import { format, parseISO } from 'date-fns';
import { useRootStore } from 'store';

export const exportColumns = (t, appStore) => {
  return [
    { fieldName: 'id', fieldTitle: t('ID'), fieldType: 'TEXT' },
    ...(appStore.isPlatformOwner
      ? [{ fieldName: 'contributor.name', fieldTitle: t('Υπόχρεος'), fieldType: 'TEXT' }]
      : []),
    { fieldName: 'year', fieldTitle: t('Έτος'), fieldType: 'TEXT' },
    { fieldName: 'contributionperiod.name', fieldTitle: t('Περίοδος'), fieldType: 'TEXT' },
    { fieldName: 'contributionstate.name', fieldTitle: t('Κατάσταση'), fieldType: 'TEXT' },
    { fieldName: 'series.name', fieldTitle: t('Σειρά'), fieldType: 'TEXT' },
    { fieldName: 'declarationDate', fieldTitle: t('Ημ/νία Δήλωσης'), fieldType: 'DATE' },
    { fieldName: 'totalCost', fieldTitle: t('Εισφορές'), fieldType: 'NUMBER' },
    { fieldName: 'isCanceled', fieldTitle: t('Ακυρωμένη'), fieldType: 'BOOLEAN' },
    ...(appStore.isPlatformOwner
      ? [{ fieldName: 'releaseToErp', fieldTitle: t('Διαθέσιμη στο ERP'), fieldType: 'BOOLEAN' }]
      : []),
    { fieldName: 'isInvoiced', fieldTitle: t('Τιμολογημένη'), fieldType: 'BOOLEAN' },
  ];
};

export async function handleExport(client, queryState: any, t, appStore): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetQuery, { onCompleted: transformData });
    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);
    function transformData(data) {
      const recs = data.getCntContributions.data.map((values) => {
        return {
          ...values,
          isActive: !values.isActive ? t('ΟΧΙ') : t('ΝΑΙ'),
          firstRec: ` ${
            values.firstDate ? format(parseISO(values.firstDate), 'dd/MM/yy HH:mm') : ''
          }  - ${values.firstUser}`,
          lastRec: ` ${
            values.lastDate ? format(parseISO(values.lastDate), 'dd/MM/yy HH:mm') : ''
          }  - ${values.lastUser}`,
        };
      });
      const trsData = {
        getCntContributions: { data: recs, recordCount: data?.getCntContributions?.recordCount },
      };
      setResult([get, { loading, data: trsData }]);
    }
    return result;
  }
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'export Table of Reports',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t, appStore),
    filterVariables: filterVariables,
  });
}

